import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';
import ViewModel from '@bingads-webui-campaign-legacy/editorial-appeal/viewmodel/editor';
import template from '@bingads-webui-campaign-legacy/editorial-appeal/template/editor.pug';
import reasonsTemplate from '@bingads-webui-campaign-legacy/editorial-appeal/template/reasons.pug';
import inlineFormTemplate from '@bingads-webui-campaign-legacy/editorial-appeal/template/inline-form.pug';
import notAppealableTemplate from '@bingads-webui-campaign-legacy/editorial-appeal/template/not-appealable.pug';
import cancelButtonTemplate from '@bingads-webui-campaign-legacy/editorial-appeal/template/cancel-button.pug';
import buttonPanelTemplate from '@bingads-webui-campaign-legacy/editorial-appeal/template/button-panel.pug';

const legacy$ = $;
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/editorial-appeal');

function removeDotAtTail(str) {
  if (_.last(str) === '.') {
    return _.initial(str).join('');
  }

  return str;
}

export default class AppealView extends Backbone.View {
  initialize({
    controlId = 'control',
    appealData: {
      EntityType = 'entity',
      RejectedReasons = [],
    } = {},
    hideAppealCheckBox = false,
    appealTitle = i18n.get('EditorialAppeal_AppealTitle'),
    infoMsg,
    callback = null,
    appealIds,
    containerSelector,
    isForVNext = false,
    withRealTimeUpdates = false,
  }) {
    this.hideAppealCheckBox = hideAppealCheckBox;
    this.controlId = controlId;
    this.entityType = removeDotAtTail(EntityType);
    this.appealTitle = appealTitle;
    this.infoMsg = infoMsg;
    this.reasons = RejectedReasons;
    this.callback = callback;
    this.appealIds = appealIds;
    this.containerSelector = containerSelector;
    this.isForVNext = isForVNext;
    this.withRealTimeUpdates = withRealTimeUpdates;

    this._elementId = `${controlId}_${this.entityType}`;

    this.viewModel = new ViewModel({
      i18n,
      isForVNext: this.isForVNext,
    });

    if (this.withRealTimeUpdates) {
      this.subscribeForRealTimeUpdates('justification');
      this.subscribeForRealTimeUpdates('appealed');
    }
  }

  subscribeForRealTimeUpdates(source) {
    const observable = this.viewModel[source];

    observable.subscribe((newValue) => {
      this.triggerChangeEvent(source, newValue);
    }, undefined, 'change');
  }

  triggerChangeEvent(/* source, newValue */) {
    if (this.withRealTimeUpdates) {
      this.trigger('change', this.getAppealData(), this.validate());
    }
  }

  validate() {
    return this.viewModel.validate();
  }

  render() {
    this.$el.html(template({
      controlId: this._elementId,
      i18n,
      isForVNext: this.isForVNext,
      infoMsg: this.infoMsg,
    }));

    ko.applyBindings(this.viewModel, this.el);

    this._create();
    this._init();

    return this;
  }

  getAppealParams() {
    const userAppealed = this.viewModel.appealed();

    const params = {
      'EditorialAppeal.Appeal': userAppealed.toString(),
      'EditorialAppeal.EntityType': this.entityType,
    };

    if (userAppealed) {
      params['EditorialAppeal.Justification'] = this.viewModel.justification();
    }

    return params;
  }

  getAppealData() {
    const userAppealed = this.viewModel.appealed();

    if (userAppealed) {
      const appealModel = {
        Prefix: 'EditorialAppeal',
        Appeal: userAppealed.toString(),
        EntityType: this.entityType,
        Justification: this.viewModel.justification(),
      };

      return appealModel;
    }

    return null;
  }

  getValidateParams() {
    // TODO: [zhbliu] this is DOM id/name
    const textAreaId = this.getAppealJustificationName();

    return {
      rules: {
        [textAreaId]: { required: true },
      },
      messages: {
        [textAreaId]: { required: i18n.get('EditorialAppeal_JustificationRequired') },
      },
      errorElement: 'div',
      errorPlacement(error, element) {
        element.parent().append(error);
      },
    };
  }

  getAppealIds() {
    return this.appealIds;
  }

  toInline(appealIds, rowId, disableAppealBtn, { appeal, cancel }) {
    if (_.isEmpty(appealIds)) {
      this.$('.details').after(notAppealableTemplate({ i18n }));
      this.$('.details').parent().append(cancelButtonTemplate({ rowId, i18n }));

      this.viewModel.justificationPanelVisible(false);
      this.$('.details .non-appeal-msg-panel').show();
      this.$(`.appeal[data-rowid=${rowId}]`).hide();
    } else {
      this.$('.details').parent().append(buttonPanelTemplate({ rowId, i18n }));
    }

    this.$('.root').wrap(inlineFormTemplate({ rowId }));

    legacy$(this.$(`form.inline[data-rowid=${rowId}]`)).validate(this.getValidateParams());

    this.$(`.cancel[data-rowid=${rowId}]`).click(cancel);

    if (disableAppealBtn) {
      this.$(`.appeal[data-rowid=${rowId}]`).attr('disabled', 'disabled');
    } else {
      this.$(`.appeal[data-rowid=${rowId}]`).click(appeal);
    }

  }

  toBulk(appealIds) {
    const $noAppealMessagePanel = this.$('.details .non-appeal-msg-panel');
    const emptyLength = 0;

    if (_.isEmpty(appealIds)) {
      if ($noAppealMessagePanel.length === emptyLength) {
        this.$('.details').after(notAppealableTemplate({ i18n }));
      }

      this.viewModel.justificationPanelVisible(false);
      $noAppealMessagePanel.show();
    } else {
      this.viewModel.justificationPanelVisible(true);
      $noAppealMessagePanel.hide();
    }
  }

  getAppealJustificationName() {
    return this.$('.justification').attr('name');
  }

  _create() {
    if (this.callback) {
      this.callback(this.$el);
      this.$('.details').addClass('appeal-kw-details').parent();
    } else {
      $(this.containerSelector).append(this.$el);
      if (!this.isForVNext) {
        legacy$(this.$('.justification').closest('form')).validate().settings.messages[this.$('.justification').attr('name')] = {
          required: i18n.get('EditorialAppeal_JustificationRequired'),
        };
      }
    }
  }

  _init() {
    if (this.appealTitle) {
      this.$('.title').text(this.appealTitle);
    }

    if (_.isArray(this.reasons)) {
      const data = {
        reasons: _.uniq(this.reasons),
      };

      this.$('.reasons').html(reasonsTemplate(data));
    }

    if (!this.isForVNext) {
      legacy$(this.$('.justification')).counter(i18n.get('Ad_CharacterRemaning'), null, i18n.get('Counter_CharacterExceeded'));
    }

    this.$('.root').show();
    this.viewModel.justification('');

    if (this.hideAppealCheckBox) {
      this.viewModel.appealedVisible(false);
      this.viewModel.appealed(true);
    } else {
      this.viewModel.appealedVisible(true);
      this.viewModel.appealed(false);
    }

    if (this.controlId === 'adAppeal') {
      this.$('.ad-info').show();
    } else {
      this.$('.ad-info').hide();
    }
  }
}
